import AgreementContent from '@/pages/information/artwork-agreement/AgreementContent';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import PopupToBottomSheet from '@/shared-components/popups/components/PopupToBottomSheet';
import Text from '@/shared-components/text/components/Text';

import './styles/ArtworkTerms.css';

export default function ArtworkTerms({ open, close }) {
  return (
    <>
      <PopupToBottomSheet className="artwork-terms" open={open} close={close} popupOptions={{ opacity: true }}>
        <div className="artwork-terms-container">
          <div className="artwork-terms__header">
            <Text className="artwork-terms__header-text" medium>Artwork Agreement</Text>
            <XIcon className="artwork-terms__close" onClick={close}/>
          </div>

          <AgreementContent />
        </div>
      </PopupToBottomSheet>
    </>
  );
}
